// useDocumentTitle.js
import { brand } from "../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useRef, useEffect } from "react";

function useDocumentTitle(title, prevailOnUnmount = true) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    if (document.title.length === 0) {
      document.title = brand.name;
    } else {
      document.title = `${title} | ${brand.name}`;
    }
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = defaultTitle.current;
      }
    },
    []
  );
}

export default useDocumentTitle;
